import { render, staticRenderFns } from "./courseOffline.vue?vue&type=template&id=6fccc999&scoped=true&"
import script from "./courseOffline.vue?vue&type=script&lang=js&"
export * from "./courseOffline.vue?vue&type=script&lang=js&"
import style0 from "./courseOffline.vue?vue&type=style&index=0&id=6fccc999&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fccc999",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fccc999')) {
      api.createRecord('6fccc999', component.options)
    } else {
      api.reload('6fccc999', component.options)
    }
    module.hot.accept("./courseOffline.vue?vue&type=template&id=6fccc999&scoped=true&", function () {
      api.rerender('6fccc999', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/courseOffline.vue"
export default component.exports